import { getRootEnv } from '@bringg-frontend/bringg-web-infra';

export const getAllUserTypes = async () => {
	const userTypes = await getRootEnv().dashboardSdk.sdk.userTypes.getAll();
	return userTypes.user_types;
};
